<template>
    <div>
      <v-icon v-if="params.value" :name="icon" scale="1.3" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="clicked" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererAction',
  computed: {
    icon () {
      const { icon } = this.params;
      const brand = (this.params.brand) ? this.params.brand : 'regular';

      return `${brand}/${icon}`;

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  },
  methods: {
    clicked() {
      const { keyFields, data, action } = this.params;

      const returnData = {
        action: action,
        params: {},
      };
      for (var i = 0; i < keyFields.length; i++) {
        var key = keyFields[i];
        returnData.params[key] = data[key];
      }

      this.$parent.$emit('custom', returnData);
    }
  }
}
</script>
